var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Theme from '../Theme';
export default class Hairline extends Component {
    render() {
        const _a = this.props, { horizontal, vertical, style } = _a, props = __rest(_a, ["horizontal", "vertical", "style"]);
        return (React.createElement("div", Object.assign({}, props, { style: Object.assign({ width: vertical ? Theme.size.hairline : undefined, height: horizontal ? Theme.size.hairline : vertical ? '100%' : undefined, backgroundColor: Theme.color.hairline }, style) })));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/elements/Hairline.tsx
// module id = 385
// module chunks = 0